import { render } from "./contact.vue?vue&type=template&id=a8736e58&scoped=true"
import script from "./contact.vue?vue&type=script&lang=js"
export * from "./contact.vue?vue&type=script&lang=js"

import "./contact.vue?vue&type=style&index=0&id=a8736e58&lang=scss&scoped=true"

import exportComponent from "D:\\乐得科技\\官网\\shark-web-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8736e58"]])

export default __exports__